import React from "react";
import { FaStar } from "react-icons/fa";
const Star = (props) =>{
    return(<span className={`star ${props.filled ? 'filled' : ''}`} style={props.block ? {cursor:"no-drop"}: {}} onClick={props.onClick}>
    {/* ★ */}
    <FaStar/>
  </span>)
}
export default Star;